export default __webpack_public_path__ + "static/media/logo-full-white.41ac28d6.png";